import React from 'react';
import { getFileType } from 'lib/helpers';

export function Attachment({ name, url, ...rest }) {
	const fileType = getFileType(url);
	return (
		<div className="attachment">
			<i className={"icon icon-" + fileType + "-file"}></i>
			<a target="_blank" href={url} {...rest}>{name}</a>
		</div>
	)
}



// WEBPACK FOOTER //
// ./lib/components/Attachment.jsx